import React, { useMemo, useState, useEffect } from "react";
//MRT Imports
import MaterialReactTable from "material-react-table";
//Material-UI Imports
import { Box, Button } from "@mui/material";
import { Container } from "@material-ui/core";
import Cookies from "universal-cookie";
import { ToastContainer, toast } from "react-toastify";

import { cognito } from "../utils/aws";

// All employee API
const url =
  "https://9o3ax69w67.execute-api.ap-south-1.amazonaws.com/dev/admin/companies";
// const url = "http://localhost:8000/api/admin/companies";

const Companies = () => {
  const notify = () =>
    toast("Unauthorized access..!", {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      type: "warning",
    });

  const cookies = new Cookies();

  const [companiesData, setCompaniesData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCompaniesData();
  }, [url]);

  const getCompaniesData = async () => {
    const idToken = cookies.get("idToken");
    const refreshToken = cookies.get("refreshToken");
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: idToken,
      },
    });
    if (response.status === 401) {
      cognito.refreshToken(refreshToken);
      console.log(response);
      getCompaniesData();
    } else {
      const jsonData = await response.json();
      setCompaniesData(jsonData.data);
      setLoading(false);
    }
  };

  const columns = useMemo(() => [
    {
      id: "company", //id used to define `group` column
      columns: [
        {
          accessorKey: "code", //accessorFn used to join multiple data into a single cell
          id: "code", //id is still required when using accessorFn instead of accessorKey
          header: "Code",
          size: 150,
        },
        {
          accessorKey: "type", //accessorKey used to define `data` column. `id` gets set to accessorKey automatically
          enableClickToCopy: true,
          header: "Type",
          size: 200,
        },
        {
          accessorKey: "short_code", //accessorKey used to define `data` column. `id` gets set to accessorKey automatically
          enableClickToCopy: true,
          header: "Short Code",
          filterFn: "fuzzy",
          size: 200,
        },
        {
          accessorKey: "name", //accessorKey used to define `data` column. `id` gets set to accessorKey automatically
          enableClickToCopy: true,
          header: "Name",
          size: 300,
        },
        {
          accessorKey: "scheme", //accessorKey used to define `data` column. `id` gets set to accessorKey automatically
          enableClickToCopy: true,
          header: "Scheme",
          filterFn: "fuzzy",
          size: 200,
        },
        {
          accessorKey: "active_status",
          // filterVariant: 'range',
          header: "Active Status",
          size: 200,
          //custom conditional format and styling
          Cell: ({ cell }) => (
            <Box
              component="span"
              sx={(theme) => ({
                backgroundColor:
                  cell.getValue() == "N"
                    ? theme.palette.error.dark
                    : theme.palette.success.dark,
                borderRadius: "0.25rem",
                color: "#fff",
                maxWidth: "9ch",
                p: "0.25rem",
              })}
            >
              {cell.getValue()?.toLocaleString?.("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </Box>
          ),
        },
        {
          accessorFn: (row) => {
            return row.divisions.join(",  ");
          },
          // accessorKey: 'divisions', //accessorKey used to define `data` column. `id` gets set to accessorKey automatically
          enableClickToCopy: true,
          header: "Divisions",
          filterFn: "fuzzy",
          size: 200,
        },
      ],
    },
  ]);

  return (
    <div>
      <ToastContainer />
      <h2 style={{ marginTop: 20, textAlign: "center" }}>Companies</h2>
      <Container>
        <MaterialReactTable
          columns={columns}
          data={companiesData}
          enableColumnFilterModes
          enableColumnOrdering
          enableGrouping
          enablePinning
          enableRowSelection
          initialState={{
            showColumnFilters: false,
            density: "compact",
            columnVisibility: { type: false, code: false },
          }}
          positionToolbarAlertBanner="bottom"
          state={
            companiesData.length > 0
              ? { isLoading: false }
              : { isLoading: true }
          }
          muiTableBodyProps={{
            sx: {
              //stripe the rows, make odd rows a darker color
              "& tr:nth-of-type(odd)": {
                backgroundColor: "#3246c41a",
              },
            },
          }}
        />
      </Container>
    </div>
  );
};

export default Companies;
